export const IconClose = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.711388 0.646447C0.90665 0.451184 1.22323 0.451184 1.41849 0.646447L14.3532 13.5811C14.5484 13.7764 14.5484 14.093 14.3532 14.2882C14.1579 14.4835 13.8413 14.4835 13.6461 14.2882L0.711388 1.35355C0.516126 1.15829 0.516126 0.841709 0.711388 0.646447Z"
        fill="#232323"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3534 0.646447C14.5486 0.841709 14.5486 1.15829 14.3534 1.35355L1.41869 14.2882C1.22343 14.4835 0.90685 14.4835 0.711588 14.2882C0.516326 14.093 0.516326 13.7764 0.711588 13.5811L13.6463 0.646447C13.8415 0.451184 14.1581 0.451184 14.3534 0.646447Z"
        fill="#232323"
      />
    </svg>
  )
}
export const IconLogout = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5"
        stroke="#676767"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.334 14.1673L17.5007 10.0007L13.334 5.83398"
        stroke="#676767"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 10H7.5"
        stroke="#676767"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export const IconArrow = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 0.99955L7.70713 6.29281C7.3166 6.68337 6.6834 6.68337 6.29287 6.29281L1 0.99955"
        stroke="#676767"
        stroke-linecap="round"
      />
    </svg>
  )
}
export const IconLogoDeNet = () => {
  return (
    <svg
      width="86"
      height="17"
      viewBox="0 0 130 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path d="M5.92 11.52C4.576 11.52 3.424 12.096 2.72 13.184V8.128H1.584V20H2.672V18.336C3.36 19.472 4.528 20.08 5.92 20.08C8.32 20.08 10.112 18.336 10.112 15.792C10.112 13.248 8.32 11.52 5.92 11.52ZM5.84 19.072C4.048 19.072 2.704 17.76 2.704 15.792C2.704 13.824 4.048 12.512 5.84 12.512C7.616 12.512 8.976 13.824 8.976 15.792C8.976 17.76 7.616 19.072 5.84 19.072ZM18.9454 11.584L15.7774 18.736L12.6094 11.584H11.4254L15.1854 19.984L14.8174 20.8C14.3374 21.856 13.8254 22.208 13.0734 22.208C12.4654 22.208 11.9534 21.984 11.5374 21.568L11.0094 22.416C11.5214 22.928 12.2734 23.184 13.0574 23.184C14.2574 23.184 15.1534 22.656 15.8574 21.008L20.0654 11.584H18.9454Z" fill="black"/>
        <g clip-path="url(#clip0_12767_65306)">
          <path d="M46.3191 6.79507C45.7532 6.71782 45.2229 6.4745 44.7954 6.09586C44.3678 5.71722 44.0621 5.22031 43.917 4.66793C43.7719 4.11555 43.7939 3.53251 43.9801 2.99261C44.1664 2.45271 44.5086 1.9802 44.9634 1.63479C45.4183 1.28939 45.9653 1.0866 46.5354 1.05214C47.1055 1.01767 47.673 1.15305 48.1661 1.44115C48.6592 1.72924 49.0559 2.15714 49.3058 2.67067C49.5558 3.1842 49.6478 3.76029 49.5703 4.32613C49.4657 5.08429 49.0647 5.77005 48.4552 6.23291C47.8457 6.69577 47.0775 6.89791 46.3191 6.79507ZM46.909 2.48096C46.6218 2.44146 46.3292 2.48804 46.0685 2.61483C45.8077 2.74162 45.5904 2.94292 45.444 3.19324C45.2976 3.44356 45.2288 3.73162 45.2462 4.02106C45.2636 4.3105 45.3665 4.58829 45.5418 4.81926C45.7172 5.05022 45.957 5.224 46.2311 5.3186C46.5052 5.41321 46.8012 5.42443 47.0817 5.35077C47.3621 5.27712 47.6145 5.12193 47.8067 4.90485C47.9989 4.68777 48.1225 4.41851 48.1617 4.13121C48.2135 3.7464 48.1108 3.35677 47.876 3.04749C47.6413 2.73822 47.2936 2.53452 46.909 2.48096Z" fill="#232323"/>
          <path d="M50.4574 9.28662C50.6736 10.4626 50.6991 11.6656 50.5328 12.8497C50.2028 15.2563 49.107 17.4927 47.4075 19.2283C45.7079 20.9638 43.4949 22.1062 41.0958 22.4864C38.6966 22.8667 36.2388 22.4647 34.0859 21.3399C31.9329 20.215 30.1992 18.427 29.1412 16.2405C28.0832 14.0539 27.7571 11.5848 28.2111 9.19855C28.6651 6.81227 29.8751 4.6355 31.6621 2.99022C33.4492 1.34494 35.7183 0.318533 38.1339 0.0628539C40.5495 -0.192825 42.9832 0.335821 45.0751 1.57054L44.3526 2.792C42.4254 1.65713 40.17 1.21001 37.9556 1.52384C35.7412 1.83767 33.6989 2.89385 32.1629 4.51954C30.6269 6.14523 29.6883 8.24416 29.5005 10.4728C29.3127 12.7015 29.887 14.9278 31.1293 16.7876C32.3717 18.6474 34.2085 20.0303 36.3392 20.7102C38.4698 21.3902 40.7682 21.3267 42.8582 20.5303C44.9481 19.7339 46.7058 18.2517 47.8436 16.3262C48.9815 14.4007 49.432 12.146 49.1216 9.93114" fill="#232323"/>
        </g>
        <g clip-path="url(#clip1_12767_65306)">
          <path d="M61 7.40473H72.0515V2H73.4631V19.9082H72.0515V8.81641H62.452V18.4965H72.0515L70.6398 19.9082H61V7.40473Z" fill="#232323"/>
          <path d="M82.3765 18.7749C79.4321 18.7749 77.2944 16.4356 77.2944 13.6122H88.2652C88.1442 9.17548 85.5225 7.07812 82.0941 7.07812C78.5851 7.07812 75.7617 9.98216 75.7617 13.5719C75.7617 17.1616 78.5044 20.0656 82.3765 20.0656C84.5948 20.0656 86.0468 19.0573 87.1762 18.0489L86.2485 17.0406C85.2402 17.9279 84.1511 18.7749 82.3765 18.7749ZM82.0538 8.40914C84.3528 8.40914 86.3292 9.74015 86.6115 12.3215H77.4154C77.8591 9.98216 79.8354 8.40914 82.0538 8.40914Z" fill="#232323"/>
          <path d="M94.3551 19.9097H90.5234V7.40625H94.3551V11.1976L98.1465 7.40625H103.027V19.9097H99.1952V11.1976H94.3551V19.9097Z" fill="#232323"/>
          <path d="M108.674 12.0379H113.837C113.635 10.7069 112.506 10.1019 111.296 10.1019C110.368 10.1422 109.037 10.5456 108.674 12.0379ZM105.004 13.6109C105.004 9.90022 107.626 7.11719 111.498 7.11719C114.684 7.11719 117.588 9.21454 117.588 13.2076C117.588 13.5706 117.548 13.9336 117.507 14.3369H108.674C108.836 16.031 110.288 16.6763 111.417 16.6763C112.587 16.6763 113.313 15.9906 113.837 15.0629L116.983 16.9183C115.813 18.7333 113.958 20.145 111.457 20.145C108.069 20.1047 105.004 17.483 105.004 13.6109Z" fill="#232323"/>
          <path d="M125.291 3.61719V7.40856H129.405V10.7563H125.291V16.4433H129.405V19.912H121.46V10.7563H118.152L125.291 3.61719Z" fill="#232323"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12767_65306">
          <rect width="23" height="23" fill="white" transform="translate(28)"/>
        </clipPath>
        <clipPath id="clip1_12767_65306">
          <rect width="69" height="19" fill="white" transform="translate(61 2)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconSend = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.9987 0.46449C20.9905 0.348609 20.9421 0.23504 20.8536 0.146447C20.7103 0.00321586 20.5018 -0.0349508 20.3238 0.0319468L0.334827 7.02808C0.141327 7.09581 0.00877504 7.27479 0.000418142 7.47963C-0.00793876 7.68447 0.109593 7.87366 0.296933 7.95692L9.1212 11.8788L13.0431 20.7031C13.1264 20.8904 13.3155 21.008 13.5204 20.9996C13.7252 20.9912 13.9042 20.8587 13.9719 20.6652L20.9684 0.67535C20.9937 0.607691 21.0038 0.535654 20.9987 0.46449ZM18.5971 1.69576L1.85554 7.55532L9.38926 10.9036L18.5971 1.69576ZM10.0964 11.6107L19.3043 2.40283L13.4447 19.1445L10.0964 11.6107Z"
        fill="white"
      />
    </svg>
  )
}
export const IconCopy = () => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.10526 2C4.10526 0.895431 5.02426 0 6.1579 0H10.9474C12.081 0 13 0.895431 13 2V10C13 11.1046 12.081 12 10.9474 12H8.89474C8.89474 13.1046 7.97574 14 6.84211 14H2.05263C0.918994 14 0 13.1046 0 12V4C0 2.89543 0.918995 2 2.05263 2L4.10526 2ZM6.1579 0.666667H10.9474C11.7031 0.666667 12.3158 1.26362 12.3158 2V10C12.3158 10.7364 11.7031 11.3333 10.9474 11.3333H8.89474V4C8.89474 2.89543 7.97574 2 6.84211 2L4.78947 2C4.78947 1.26362 5.40214 0.666667 6.1579 0.666667Z"
        fill="#ACADB5"
      />
    </svg>
  )
}

export const IconRedmine = () => {
  return (
    <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.886719 13.9993H5.34126L5.65945 10.1808L1.52282 9.22656L0.886719 13.9993Z" fill="#4C4C4C"/>
      <path d="M1.68164 8.58922L5.65891 9.54377L6.61346 6.20286L3.27255 4.45312L1.68164 8.58922Z" fill="#4C4C4C"/>
      <path d="M3.5918 3.82173L6.77362 5.57173L9.31933 3.82173L6.93297 1.11719L3.5918 3.82173Z" fill="#4C4C4C"/>
      <path d="M21.4094 13.9993H16.9552L16.6367 10.1808L20.7733 9.22656L21.4094 13.9993Z" fill="#4C4C4C"/>
      <path d="M20.6132 8.58922L16.6359 9.54377L15.6816 6.20286L19.0223 4.45312L20.6132 8.58922Z" fill="#4C4C4C"/>
      <path d="M18.7055 3.82173L15.5237 5.57173L12.9785 3.82173L15.3649 1.11719L18.7055 3.82173Z" fill="#4C4C4C"/>
      <path d="M7.72852 0.636364L10.1149 3.5H12.3419L14.4103 0.636364L12.3419 0H10.0589L7.72852 0.636364Z" fill="#4C4C4C"/>
      <path d="M0.886719 13.9993H5.34126L5.65945 10.1808L1.52282 9.22656L0.886719 13.9993Z" fill="#9C0000"/>
      <path d="M1.68164 8.58922L5.65891 9.54377L6.61346 6.20286L3.27255 4.45312L1.68164 8.58922Z" fill="#B50808"/>
      <path d="M3.5918 3.82173L6.77362 5.57173L9.31933 3.82173L6.93297 1.11719L3.5918 3.82173Z" fill="#C61818"/>
      <path d="M21.4094 13.9993H16.9552L16.6367 10.1808L20.7733 9.22656L21.4094 13.9993Z" fill="#9C0000"/>
      <path d="M20.6132 8.58922L16.6359 9.54377L15.6816 6.20286L19.0223 4.45312L20.6132 8.58922Z" fill="#B50808"/>
      <path d="M18.7055 3.82173L15.5237 5.57173L12.9785 3.82173L15.3649 1.11719L18.7055 3.82173Z" fill="#C61818"/>
      <path d="M7.72852 0.636364L10.1149 3.5H12.3419L14.4103 0.636364L12.3419 0H10.0589L7.72852 0.636364Z" fill="#CE3129"/>
    </svg>
  )
}

export const IconUpload = () => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.5856 12.5305L13.6186 23.4975C12.2751 24.841 10.4529 25.5958 8.55281 25.5958C6.65276 25.5958 4.83054 24.841 3.487 23.4975C2.14346 22.1539 1.38867 20.3317 1.38867 18.4317C1.38867 16.5316 2.14346 14.7094 3.487 13.3659L14.454 2.39888C15.3497 1.50319 16.5645 1 17.8312 1C19.0979 1 20.3127 1.50319 21.2084 2.39888C22.1041 3.29458 22.6073 4.50939 22.6073 5.77609C22.6073 7.04279 22.1041 8.25761 21.2084 9.1533L10.2295 20.1203C9.78163 20.5681 9.17422 20.8197 8.54088 20.8197C7.90753 20.8197 7.30012 20.5681 6.85227 20.1203C6.40443 19.6724 6.15283 19.065 6.15283 18.4317C6.15283 17.7983 6.40443 17.1909 6.85227 16.7431L16.9839 6.62338"
        stroke="black"
        stroke-width="0.650923"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M24.1969 12.5305L13.2299 23.4975C11.8864 24.841 10.0642 25.5958 8.16414 25.5958C6.26409 25.5958 4.44186 24.841 3.09833 23.4975C1.75479 22.1539 1 20.3317 1 18.4317C1 16.5316 1.75479 14.7094 3.09833 13.3659L14.0653 2.39888C14.961 1.50319 16.1758 1 17.4425 1C18.7092 1 19.924 1.50319 20.8197 2.39888C21.7154 3.29458 22.2186 4.50939 22.2186 5.77609C22.2186 7.04279 21.7154 8.25761 20.8197 9.1533L9.84081 20.1203C9.39296 20.5681 8.78555 20.8197 8.1522 20.8197C7.51885 20.8197 6.91145 20.5681 6.4636 20.1203C6.01576 19.6724 5.76416 19.065 5.76416 18.4317C5.76416 17.7983 6.01576 17.1909 6.4636 16.7431L16.5952 6.62338"
        stroke="black"
        stroke-width="0.650923"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export const IconDenet = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="icon-denet"
    >
      <g
        clip-path="url(#clip0_15_3679)"
      >
        <path
          d="M15.9289 6.40663C15.4369 6.33946 14.9758 6.12788 14.604 5.79862C14.2322 5.46937 13.9664 5.03728 13.8402 4.55695C13.714 4.07662 13.7331 3.56962 13.8951 3.10015C14.057 2.63067 14.3546 2.21979 14.7501 1.91944C15.1456 1.61909 15.6213 1.44275 16.1171 1.41278C16.6128 1.38281 17.1063 1.50053 17.5351 1.75105C17.9639 2.00156 18.3088 2.37365 18.5261 2.8202C18.7435 3.26674 18.8235 3.76769 18.7561 4.25973C18.6651 4.919 18.3164 5.51531 17.7864 5.9178C17.2564 6.32028 16.5884 6.49606 15.9289 6.40663ZM16.4419 2.65523C16.1921 2.62089 15.9378 2.66139 15.711 2.77165C15.4843 2.8819 15.2953 3.05694 15.168 3.27461C15.0407 3.49227 14.9809 3.74276 14.996 3.99445C15.0112 4.24614 15.1006 4.4877 15.2531 4.68853C15.4055 4.88937 15.6141 5.04048 15.8525 5.12275C16.0908 5.20502 16.3482 5.21477 16.5921 5.15072C16.836 5.08667 17.0554 4.95173 17.2225 4.76296C17.3897 4.5742 17.4971 4.34006 17.5312 4.09023C17.5763 3.75562 17.487 3.41681 17.2828 3.14787C17.0787 2.87894 16.7763 2.70181 16.4419 2.65523Z"
          fill="#232323"
        />
        <path
          d="M19.5278 8.57532C19.7157 9.59789 19.7379 10.644 19.5933 11.6736C19.3064 13.7663 18.3535 15.7111 16.8756 17.2202C15.3978 18.7294 13.4734 19.7227 11.3872 20.0534C9.30101 20.3841 7.16376 20.0345 5.29164 19.0564C3.41952 18.0783 1.91195 16.5235 0.991938 14.6222C0.0719251 12.7208 -0.211658 10.5738 0.183124 8.49874C0.577906 6.42371 1.63008 4.53087 3.18403 3.10019C4.73798 1.66951 6.71116 0.776985 8.81168 0.554656C10.9122 0.332326 13.0285 0.792018 14.8475 1.86569L14.2192 2.92783C12.5434 1.94098 10.5822 1.55218 8.65665 1.82508C6.73108 2.09798 4.95515 3.01639 3.61952 4.43003C2.28388 5.84368 1.46763 7.66884 1.30436 9.60679C1.14108 11.5447 1.64044 13.4807 2.72073 15.0979C3.80101 16.7151 5.39824 17.9177 7.25101 18.5089C9.10378 19.1001 11.1024 19.045 12.9197 18.3524C14.737 17.6599 16.2655 16.371 17.2549 14.6967C18.2443 13.0224 18.6361 11.0618 18.3662 9.13577"
          fill="#232323"
        />
      </g>
      <defs>
        <clipPath
          id="clip0_15_3679"
        >
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconDone = () => {
  return (
    <svg
      width="47"
      height="46"
      viewBox="0 0 47 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23.5"
        cy="23"
        r="23"
        fill="#32A243"
      />
      <path
        d="M13.5 23.3056L20.606 31.0038C20.899 31.3212 21.4072 31.2984 21.6706 30.956L33.9444 15"
        stroke="white"
        stroke-width="2.78788"
        stroke-linecap="round"
      />
    </svg>
  )
}
export const IconDelete = () => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4.08262H3.23404M21 4.08262H18.766M18.766 4.08262L18.0643 21.0413C18.0421 21.5771 17.6013 22 17.0651 22H4.94117C4.40511 22 3.9644 21.5773 3.94204 21.0417L3.23404 4.08262M18.766 4.08262L14.1948 4.08187M3.23404 4.08262H7.81183M7.81183 4.08262V2C7.81183 1.44771 8.25955 1 8.81183 1H13.1954C13.7478 1 14.1955 1.44788 14.1954 2.00027L14.1948 4.08187M7.81183 4.08262L14.1948 4.08187"
        stroke="#676767"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="icon-delete__color"
      />
      <path
        d="M11 8V18M14.5 8V18M7.5 8V18"
        stroke="#676767"
        stroke-linecap="round"
        class="icon-delete__color"
      />
    </svg>
  )
}
export const IconChevronDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M5.6333 5.61261L0.683302 1.48761"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.6316 5.61303L10.5815 1.48804"
        stroke="#232323"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export const IconDownload = () => {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.499945 12H9.49994C9.62489 11.9998 9.74539 12.0463 9.83773 12.1305C9.93006 12.2147 9.98753 12.3304 9.99882 12.4548C10.0101 12.5793 9.9744 12.7034 9.89872 12.8028C9.82305 12.9023 9.71289 12.9697 9.58994 12.992L9.49994 13H0.499945C0.374999 13.0002 0.254495 12.9537 0.162162 12.8695C0.069829 12.7853 0.0123591 12.6696 0.00106967 12.5452C-0.0102198 12.4207 0.0254892 12.2966 0.101165 12.1972C0.17684 12.0977 0.286998 12.0303 0.409945 12.008L0.499945 12H9.49994H0.499945ZM4.90995 0.00800004L4.99995 2.78103e-08C5.11697 -3.89861e-05 5.2303 0.0409714 5.3202 0.115889C5.41011 0.190807 5.47088 0.294886 5.49194 0.41L5.49995 0.5V9.292L8.18194 6.611C8.26468 6.52817 8.37385 6.477 8.49044 6.4664C8.60702 6.4558 8.72363 6.48645 8.81994 6.553L8.88995 6.611C8.97262 6.69386 9.02361 6.80309 9.03402 6.91967C9.04444 7.03626 9.01362 7.1528 8.94694 7.249L8.88894 7.318L5.35395 10.854C5.27109 10.9367 5.16186 10.9877 5.04527 10.9981C4.92869 11.0085 4.81214 10.9777 4.71595 10.911L4.64595 10.854L1.11095 7.318C1.02236 7.22981 0.970022 7.11164 0.964242 6.98678C0.958463 6.86191 0.999662 6.73941 1.07972 6.64342C1.15978 6.54742 1.27289 6.4849 1.39676 6.46816C1.52063 6.45142 1.64628 6.48169 1.74895 6.553L1.81794 6.611L4.49995 9.292V0.5C4.49991 0.382974 4.54092 0.269643 4.61583 0.179741C4.69075 0.0898397 4.79483 0.0290646 4.90995 0.00800004L4.99995 2.78103e-08L4.90995 0.00800004Z"
        fill="#ACADB5"
      />
    </svg>
  )
}
export const DefenderLogo = () => {
  return (
    <svg
      width="143"
      height="114"
      viewBox="0 0 143 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 26.2478H53.6708V0H60.5265V86.9702H53.6708V80.1144V33.1035H7.05164V80.1144H53.6708L46.815 86.9702H0V26.2478ZM142.644 87.0179H88.9736V113.266H82.1178V26.2954H88.9736V33.1512V80.1621H135.593V33.1512H88.9736L95.8293 26.2954H142.644V87.0179ZM71.3218 86.9571C73.378 86.9571 75.0449 85.2902 75.0449 83.234C75.0449 81.1778 73.378 79.5109 71.3218 79.5109C69.2656 79.5109 67.5987 81.1778 67.5987 83.234C67.5987 85.2902 69.2656 86.9571 71.3218 86.9571Z"
        fill="#232323"
      />
    </svg>
  )
}
export const MetamaskLogo = () => {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9123 1L13.3179 7.35923L14.9161 3.61153L21.9123 1Z"
        fill="#E17726"
        stroke="#E17726"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.08838 1L10.6062 7.41858L9.0846 3.61152L2.08838 1Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.8175 15.7452L16.5308 19.2385L21.4272 20.5867L22.8299 15.8215L18.8175 15.7452Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.17822 15.8215L2.57235 20.5867L7.46036 19.2385L5.18212 15.7452L1.17822 15.8215Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.19703 9.84437L5.83691 11.8963L10.6824 12.1168L10.5209 6.90219L7.19703 9.84437Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.8032 9.84358L13.4284 6.84203L13.3179 12.116L18.1633 11.8955L16.8032 9.84358Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.46045 19.2382L10.3932 17.8223L7.86851 15.8552L7.46045 19.2382Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.6064 17.8223L16.5307 19.2382L16.1311 15.8552L13.6064 17.8223Z"
        fill="#E27625"
        stroke="#E27625"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5307 19.2391L13.6064 17.8231L13.8444 19.7224L13.8189 20.5279L16.5307 19.2391Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.46045 19.2391L10.1807 20.5279L10.1637 19.7224L10.3932 17.8231L7.46045 19.2391Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2316 14.6008L7.80029 13.8886L9.51745 13.1L10.2316 14.6008Z"
        fill="#233447"
        stroke="#233447"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7681 14.6008L14.4822 13.1L16.2078 13.8886L13.7681 14.6008Z"
        fill="#233447"
        stroke="#233447"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.46034 19.2385L7.88541 15.7452L5.18213 15.8215L7.46034 19.2385Z"
        fill="#CC6228"
        stroke="#CC6228"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.1143 15.7452L16.5308 19.2385L18.8175 15.8215L16.1143 15.7452Z"
        fill="#CC6228"
        stroke="#CC6228"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1633 11.8952L13.3179 12.1156L13.7684 14.6L14.4825 13.0992L16.2082 13.8877L18.1633 11.8952Z"
        fill="#CC6228"
        stroke="#CC6228"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.8006 13.8877L9.51777 13.0992L10.2319 14.6L10.6824 12.1156L5.83691 11.8952L7.8006 13.8877Z"
        fill="#CC6228"
        stroke="#CC6228"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.8374 11.8952L7.86912 15.8549L7.80107 13.8877L5.8374 11.8952Z"
        fill="#E27525"
        stroke="#E27525"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.2078 13.8877L16.1313 15.8549L18.1631 11.8952L16.2078 13.8877Z"
        fill="#E27525"
        stroke="#E27525"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6825 12.1152L10.2319 14.5996L10.8015 17.5332L10.929 13.6668L10.6825 12.1152Z"
        fill="#E27525"
        stroke="#E27525"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3176 12.1152L13.0796 13.6584L13.1986 17.5332L13.7682 14.5996L13.3176 12.1152Z"
        fill="#E27525"
        stroke="#E27525"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7683 14.6012L13.1987 17.5348L13.6068 17.8232L16.1316 15.856L16.208 13.8889L13.7683 14.6012Z"
        fill="#F5841F"
        stroke="#F5841F"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.80029 13.8889L7.86835 15.856L10.393 17.8232L10.8011 17.5348L10.2316 14.6012L7.80029 13.8889Z"
        fill="#F5841F"
        stroke="#F5841F"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.8191 20.5265L13.8445 19.721L13.6236 19.5344H10.3763L10.1637 19.721L10.1807 20.5265L7.46045 19.2377L8.41254 20.0177L10.3422 21.3489H13.649L15.5872 20.0177L16.5308 19.2377L13.8191 20.5265Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.6069 17.8226L13.1988 17.5344H10.8016L10.3936 17.8226L10.1641 19.722L10.3766 19.5354H13.6239L13.8449 19.722L13.6069 17.8226Z"
        fill="#161616"
        stroke="#161616"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.2773 7.77468L22.9999 4.26441L21.9117 1L13.6064 7.14728L16.8027 9.84356L21.3167 11.1578L22.3113 9.99622L21.8778 9.68246L22.5663 9.05506L22.0393 8.64805L22.7278 8.12234L22.2773 7.77468Z"
        fill="#763E1A"
        stroke="#763E1A"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 4.26441L1.73107 7.77468L1.26353 8.12234L1.9606 8.64805L1.43354 9.05506L2.12211 9.68246L1.68857 9.99622L2.68317 11.1578L7.19715 9.84356L10.3934 7.14728L2.08811 1L1 4.26441Z"
        fill="#763E1A"
        stroke="#763E1A"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3169 11.1572L16.8029 9.84297L18.1631 11.8949L16.1313 15.8545L18.8176 15.8206H22.83L21.3169 11.1572Z"
        fill="#F5841F"
        stroke="#F5841F"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.19679 9.84297L2.68287 11.1572L1.17822 15.8206H5.18212L7.86836 15.8545L5.83668 11.8949L7.19679 9.84297Z"
        fill="#F5841F"
        stroke="#F5841F"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3174 12.1169L13.6064 7.1482L14.9155 3.6125H9.08398L10.3931 7.1482L10.6821 12.1169L10.7926 13.677L10.8011 17.535H13.1984L13.2069 13.677L13.3174 12.1169Z"
        fill="#F5841F"
        stroke="#F5841F"
        stroke-width="0.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
export const BugTrackerLogo = () => {
  return (
    <svg
      width="178"
      height="135"
      viewBox="0 0 178 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_54_3161" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="45" y="49" width="86" height="86">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M71.7448 50.145C70.1985 49.2533 68.2941 49.2538 66.7484 50.1464L49.2543 60.2486C47.2538 61.4038 46.0215 63.5385 46.0215 65.8486V107.173C46.0215 109.483 47.2538 111.618 49.2543 112.773L85.0456 133.441C87.04 134.593 89.4964 134.597 91.4945 133.452L127.371 112.894C129.387 111.738 130.628 109.59 130.622 107.267L130.522 65.948C130.516 63.6484 129.29 61.5248 127.301 60.3706L109.887 50.2656C108.345 49.3708 106.443 49.3651 104.895 50.2506V50.2506C101.553 52.1634 101.539 56.9786 104.869 58.9115L117.319 66.1354C119.307 67.2896 120.534 69.4132 120.539 71.7128L120.612 101.482C120.618 103.806 119.377 105.954 117.361 107.109L91.5137 121.92C89.5156 123.065 87.0592 123.061 85.0648 121.909L59.2504 107.002C57.2499 105.847 56.0176 103.712 56.0176 101.402V71.6193C56.0176 69.3092 57.2499 67.1745 59.2504 66.0193L71.7472 58.8029C75.0799 56.8784 75.0785 52.0675 71.7448 50.145V50.145Z" fill="#232323"/>
        <path d="M59.2504 107.002L59.1909 107.105L59.1909 107.105L59.2504 107.002ZM91.5137 121.92L91.4546 121.817L91.5137 121.92ZM85.0648 121.909L85.1244 121.806L85.0648 121.909ZM120.612 101.482L120.493 101.483L120.612 101.482ZM117.319 66.1354L117.259 66.2383L117.319 66.1354ZM120.539 71.7128L120.658 71.7125L120.539 71.7128ZM104.869 58.9115L104.81 59.0144L104.869 58.9115ZM109.887 50.2656L109.827 50.3685L109.887 50.2656ZM130.522 65.948L130.641 65.9477L130.522 65.948ZM127.301 60.3706L127.36 60.2677L127.301 60.3706ZM85.0456 133.441L84.9861 133.544L85.0456 133.441ZM91.4945 133.452L91.4354 133.349L91.4945 133.452ZM66.7484 50.1464L66.6889 50.0433L66.7484 50.1464ZM49.3138 60.3517L66.8079 50.2494L66.6889 50.0433L49.1948 60.1456L49.3138 60.3517ZM46.1405 107.173V65.8486H45.9025V107.173H46.1405ZM85.1052 133.338L49.3138 112.67L49.1948 112.876L84.9861 133.544L85.1052 133.338ZM127.312 112.79L91.4354 133.349L91.5537 133.555L127.43 112.997L127.312 112.79ZM130.403 65.9483L130.503 107.267L130.741 107.267L130.641 65.9477L130.403 65.9483ZM109.827 50.3685L127.241 60.4736L127.36 60.2677L109.946 50.1627L109.827 50.3685ZM104.81 59.0144L117.259 66.2383L117.378 66.0325L104.929 58.8086L104.81 59.0144ZM120.42 71.7131L120.493 101.483L120.731 101.482L120.658 71.7125L120.42 71.7131ZM117.301 107.005L91.4546 121.817L91.5729 122.023L117.42 107.212L117.301 107.005ZM85.1244 121.806L59.3099 106.899L59.1909 107.105L85.0053 122.012L85.1244 121.806ZM56.1366 101.402V71.6193H55.8986V101.402H56.1366ZM59.3099 66.1224L71.8067 58.9059L71.6877 58.6998L59.1909 65.9163L59.3099 66.1224ZM71.8067 58.9059C75.2187 56.9356 75.2173 52.0102 71.8042 50.0419L71.6853 50.2481C74.9397 52.1249 74.941 56.8211 71.6877 58.6998L71.8067 58.9059ZM56.1366 71.6193C56.1366 69.3517 57.3462 67.2563 59.3099 66.1224L59.1909 65.9163C57.1536 67.0927 55.8986 69.2667 55.8986 71.6193H56.1366ZM59.3099 106.899C57.3462 105.765 56.1366 103.67 56.1366 101.402H55.8986C55.8986 103.755 57.1536 105.929 59.1909 107.105L59.3099 106.899ZM91.4546 121.817C89.4932 122.941 87.082 122.937 85.1244 121.806L85.0053 122.012C87.0364 123.185 89.538 123.189 91.5729 122.023L91.4546 121.817ZM120.493 101.483C120.499 103.763 119.28 105.872 117.301 107.005L117.42 107.212C119.473 106.036 120.737 103.848 120.731 101.482L120.493 101.483ZM117.259 66.2383C119.211 67.3713 120.415 69.4558 120.42 71.7131L120.658 71.7125C120.653 69.3706 119.404 67.2079 117.378 66.0325L117.259 66.2383ZM104.836 50.1473C101.414 52.1057 101.4 57.0355 104.81 59.0144L104.929 58.8086C101.678 56.9217 101.692 52.2212 104.955 50.3539L104.836 50.1473ZM109.946 50.1627C108.368 49.2466 106.421 49.2407 104.836 50.1473L104.955 50.3539C106.465 49.4895 108.322 49.495 109.827 50.3685L109.946 50.1627ZM130.641 65.9477C130.635 63.6058 129.386 61.4431 127.36 60.2677L127.241 60.4736C129.193 61.6065 130.397 63.691 130.403 65.9483L130.641 65.9477ZM127.43 112.997C129.483 111.82 130.747 109.633 130.741 107.267L130.503 107.267C130.509 109.548 129.291 111.656 127.312 112.79L127.43 112.997ZM84.9861 133.544C87.0172 134.717 89.5188 134.721 91.5537 133.555L91.4354 133.349C89.474 134.473 87.0628 134.469 85.1052 133.338L84.9861 133.544ZM45.9025 107.173C45.9025 109.526 47.1575 111.699 49.1948 112.876L49.3138 112.67C47.3501 111.536 46.1405 109.441 46.1405 107.173H45.9025ZM66.8079 50.2494C68.3168 49.3781 70.1759 49.3776 71.6853 50.2481L71.8042 50.0419C70.2212 49.1289 68.2714 49.1295 66.6889 50.0433L66.8079 50.2494ZM49.1948 60.1456C47.1575 61.3221 45.9025 63.496 45.9025 65.8486H46.1405C46.1405 63.581 47.3501 61.4856 49.3138 60.3517L49.1948 60.1456Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_54_3161)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M71.7448 50.145C70.1985 49.2533 68.2941 49.2538 66.7484 50.1464L49.2543 60.2486C47.2538 61.4038 46.0215 63.5385 46.0215 65.8486V107.173C46.0215 109.483 47.2538 111.618 49.2543 112.773L85.0456 133.441C87.04 134.593 89.4964 134.597 91.4945 133.452L127.371 112.894C129.387 111.738 130.628 109.59 130.622 107.267L130.522 65.948C130.516 63.6484 129.29 61.5248 127.301 60.3706L109.887 50.2656C108.345 49.3708 106.443 49.3651 104.895 50.2506V50.2506C101.553 52.1634 101.539 56.9786 104.869 58.9115L117.319 66.1354C119.307 67.2896 120.534 69.4132 120.539 71.7128L120.612 101.482C120.618 103.806 119.377 105.954 117.361 107.109L91.5137 121.92C89.5156 123.065 87.0592 123.061 85.0648 121.909L59.2504 107.002C57.2499 105.847 56.0176 103.712 56.0176 101.402V71.6193C56.0176 69.3092 57.2499 67.1745 59.2504 66.0193L71.7472 58.8029C75.0799 56.8784 75.0785 52.0675 71.7448 50.145V50.145Z" fill="#232323"/>
        <path d="M59.2504 107.002L59.1909 107.105L59.1909 107.105L59.2504 107.002ZM91.5137 121.92L91.4546 121.817L91.5137 121.92ZM85.0648 121.909L85.1244 121.806L85.0648 121.909ZM120.612 101.482L120.493 101.483L120.612 101.482ZM117.319 66.1354L117.259 66.2383L117.319 66.1354ZM120.539 71.7128L120.658 71.7125L120.539 71.7128ZM104.869 58.9115L104.81 59.0144L104.869 58.9115ZM109.887 50.2656L109.827 50.3685L109.887 50.2656ZM130.522 65.948L130.641 65.9477L130.522 65.948ZM127.301 60.3706L127.36 60.2677L127.301 60.3706ZM85.0456 133.441L84.9861 133.544L85.0456 133.441ZM91.4945 133.452L91.4354 133.349L91.4945 133.452ZM66.7484 50.1464L66.6889 50.0433L66.7484 50.1464ZM49.3138 60.3517L66.8079 50.2494L66.6889 50.0433L49.1948 60.1456L49.3138 60.3517ZM46.1405 107.173V65.8486H45.9025V107.173H46.1405ZM85.1052 133.338L49.3138 112.67L49.1948 112.876L84.9861 133.544L85.1052 133.338ZM127.312 112.79L91.4354 133.349L91.5537 133.555L127.43 112.997L127.312 112.79ZM130.403 65.9483L130.503 107.267L130.741 107.267L130.641 65.9477L130.403 65.9483ZM109.827 50.3685L127.241 60.4736L127.36 60.2677L109.946 50.1627L109.827 50.3685ZM104.81 59.0144L117.259 66.2383L117.378 66.0325L104.929 58.8086L104.81 59.0144ZM120.42 71.7131L120.493 101.483L120.731 101.482L120.658 71.7125L120.42 71.7131ZM117.301 107.005L91.4546 121.817L91.5729 122.023L117.42 107.212L117.301 107.005ZM85.1244 121.806L59.3099 106.899L59.1909 107.105L85.0053 122.012L85.1244 121.806ZM56.1366 101.402V71.6193H55.8986V101.402H56.1366ZM59.3099 66.1224L71.8067 58.9059L71.6877 58.6998L59.1909 65.9163L59.3099 66.1224ZM71.8067 58.9059C75.2187 56.9356 75.2173 52.0102 71.8042 50.0419L71.6853 50.2481C74.9397 52.1249 74.941 56.8211 71.6877 58.6998L71.8067 58.9059ZM56.1366 71.6193C56.1366 69.3517 57.3462 67.2563 59.3099 66.1224L59.1909 65.9163C57.1536 67.0927 55.8986 69.2667 55.8986 71.6193H56.1366ZM59.3099 106.899C57.3462 105.765 56.1366 103.67 56.1366 101.402H55.8986C55.8986 103.755 57.1536 105.929 59.1909 107.105L59.3099 106.899ZM91.4546 121.817C89.4932 122.941 87.082 122.937 85.1244 121.806L85.0053 122.012C87.0364 123.185 89.538 123.189 91.5729 122.023L91.4546 121.817ZM120.493 101.483C120.499 103.763 119.28 105.872 117.301 107.005L117.42 107.212C119.473 106.036 120.737 103.848 120.731 101.482L120.493 101.483ZM117.259 66.2383C119.211 67.3713 120.415 69.4558 120.42 71.7131L120.658 71.7125C120.653 69.3706 119.404 67.2079 117.378 66.0325L117.259 66.2383ZM104.836 50.1473C101.414 52.1057 101.4 57.0355 104.81 59.0144L104.929 58.8086C101.678 56.9217 101.692 52.2212 104.955 50.3539L104.836 50.1473ZM109.946 50.1627C108.368 49.2466 106.421 49.2407 104.836 50.1473L104.955 50.3539C106.465 49.4895 108.322 49.495 109.827 50.3685L109.946 50.1627ZM130.641 65.9477C130.635 63.6058 129.386 61.4431 127.36 60.2677L127.241 60.4736C129.193 61.6065 130.397 63.691 130.403 65.9483L130.641 65.9477ZM127.43 112.997C129.483 111.82 130.747 109.633 130.741 107.267L130.503 107.267C130.509 109.548 129.291 111.656 127.312 112.79L127.43 112.997ZM84.9861 133.544C87.0172 134.717 89.5188 134.721 91.5537 133.555L91.4354 133.349C89.474 134.473 87.0628 134.469 85.1052 133.338L84.9861 133.544ZM45.9025 107.173C45.9025 109.526 47.1575 111.699 49.1948 112.876L49.3138 112.67C47.3501 111.536 46.1405 109.441 46.1405 107.173H45.9025ZM66.8079 50.2494C68.3168 49.3781 70.1759 49.3776 71.6853 50.2481L71.8042 50.0419C70.2212 49.1289 68.2714 49.1295 66.6889 50.0433L66.8079 50.2494ZM49.1948 60.1456C47.1575 61.3221 45.9025 63.496 45.9025 65.8486H46.1405C46.1405 63.581 47.3501 61.4856 49.3138 60.3517L49.1948 60.1456Z" fill="#232323"/>
      </g>
      <path
        d="M108.699 42.8132L91.5917 52.644C89.59 53.7943 87.1269 53.7902 85.1291 52.6332L68.0541 42.7452C66.0575 41.5889 64.8281 39.4564 64.8281 37.1492V17.3535C64.8281 15.0462 66.0575 12.9138 68.0541 11.7575L85.1088 1.88121C87.1175 0.717969 89.5956 0.720585 91.6018 1.88807L108.681 11.827C110.666 12.9822 111.89 15.1037 111.895 17.4004L111.944 37.1908C111.949 39.5113 110.711 41.657 108.699 42.8132Z"
        fill="#232323"
        stroke="#232323"
        stroke-width="0.238003"
      />
      <path
        d="M5.08984 87.5703L51.0244 87.5703"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
      <path
        d="M126.709 87.5703L172.644 87.5703"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
      <path
        d="M15.7832 129.555L52.4168 108.277"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
      <path
        d="M160.719 129.555L124.085 108.277"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
      <path
        d="M14.3682 45.9219L51.0017 67.1994"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
      <path
        d="M162.191 45.9219L125.558 67.1994"
        stroke="#232323"
        stroke-width="9.99612"
        stroke-linecap="round"
      />
    </svg>
  )
}
export const IconSearch = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.0498 7.5C1.0498 3.91015 3.95996 1 7.54981 1C11.1397 1 14.0498 3.91015 14.0498 7.5C14.0498 9.28552 13.3316 10.9007 12.1654 12.0767L12.2183 12.1292L12.1654 12.0767C11.7292 12.5166 11.2309 12.8943 10.6854 13.1954C9.75695 13.7079 8.68948 14 7.54981 14C3.95996 14 1.0498 11.0899 1.0498 7.5ZM13.1968 12.4359C14.3509 11.1167 15.0498 9.39025 15.0498 7.5C15.0498 3.35787 11.692 0 7.54981 0C3.40767 0 0.0498047 3.35787 0.0498047 7.5C0.0498047 11.6421 3.40767 15 7.54981 15C8.86271 15 10.096 14.663 11.1687 14.0709L10.9271 13.6331L11.1687 14.0709C11.6427 13.8092 12.0855 13.4976 12.4899 13.1433L15.2002 15.8536C15.3954 16.0488 15.712 16.0488 15.9073 15.8536C16.1025 15.6583 16.1025 15.3417 15.9073 15.1464L13.1968 12.4359Z"
        fill="#676767"
      />
    </svg>
  )
}
export const WalletConnectLogo = () => {
  return (
    <svg
      fill="none"
      height="332"
      viewBox="0 0 480 332"
      width="480"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m126.613 93.9842c62.622-61.3123 164.152-61.3123 226.775 0l7.536 7.3788c3.131 3.066 3.131 8.036 0 11.102l-25.781 25.242c-1.566 1.533-4.104 1.533-5.67 0l-10.371-10.154c-43.687-42.7734-114.517-42.7734-158.204 0l-11.107 10.874c-1.565 1.533-4.103 1.533-5.669 0l-25.781-25.242c-3.132-3.066-3.132-8.036 0-11.102zm280.093 52.2038 22.946 22.465c3.131 3.066 3.131 8.036 0 11.102l-103.463 101.301c-3.131 3.065-8.208 3.065-11.339 0l-73.432-71.896c-.783-.767-2.052-.767-2.835 0l-73.43 71.896c-3.131 3.065-8.208 3.065-11.339 0l-103.4657-101.302c-3.1311-3.066-3.1311-8.036 0-11.102l22.9456-22.466c3.1311-3.065 8.2077-3.065 11.3388 0l73.4333 71.897c.782.767 2.051.767 2.834 0l73.429-71.897c3.131-3.065 8.208-3.065 11.339 0l73.433 71.897c.783.767 2.052.767 2.835 0l73.431-71.895c3.132-3.066 8.208-3.066 11.339 0z"
        fill="#3396ff"
      />
    </svg>
  )
}
